let navigator = null;

export function setNavigator(fn) {
  navigator = fn;
}

export function appNavigate(to, options) {
  if (typeof to === 'number') {
    window.history.go(to);
    return;
  }
  if (typeof to === 'string' && /^https?:\/\//i.test(to)) {
    if (options?.replace) {
      window.location.replace(to);
    } else {
      window.location.assign(to);
    }
    return;
  }
  if (navigator) {
    navigator(to, options);
    return;
  }
  if (options?.replace) {
    window.location.replace(to);
  } else {
    window.location.assign(to);
  }
}
